require('./mortgageRequestDocumentationCenterHolders.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const { includes } = require('lodash');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKFileUpload } = require('commonsComponents/OKFileUpload');
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @ constants
const { DOCUMENTS_STATUS } = require('constants/mortgageRequestHolderData');
const { COHOLDER_ORDER, HOLDER_ORDER, UPLOAD_FILE_TYPE } = require('constants/mortgageRequestDocumentationCenter');

class MortgageRequestDocumentationCenterHolders extends React.Component {
    buildListHeader(hasCoholder) {
        const titleClassName = classNames('mortgage-request-documentation-center-holders__list-title', {
            'mortgage-request-documentation-center-holders__list-title--inline': hasCoholder
        });

        let header = (
            <FormattedText
                value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionRequiredDocuments"
                className="mortgage-request-documentation-center-holders__list-title"
            />
        );

        if (hasCoholder) {
            header = (
                <div className="mortgage-request-documentation-center-holders__list-header">
                    <FormattedText
                        value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionRequiredDocument"
                        className={titleClassName}
                    />
                    <FormattedText
                        value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFirstHolder"
                        className={titleClassName}
                    />
                    <FormattedText
                        value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionSecondHolder"
                        className={titleClassName}
                    />
                </div >
            );
        }

        return header;
    }

    buildParams(holderDocumentData) {
        const {
            idDocumentType,
            idDocumentNumber,
            documentType,
            documentId,
            mortgageOtherDocumentId
        } = holderDocumentData;
        const params = {
            idDocumentType,
            idDocumentNumber,
            documentType
        };

        if (documentId) {
            params['documentId'] = documentId;
        } else if (mortgageOtherDocumentId) {
            params['mortgageOtherDocumentId'] = mortgageOtherDocumentId
        }

        return params;
    }

    handleUploadFile(file, holderDocumentData) {
        const { uploadFile } = this.props;
        const params = this.buildParams(holderDocumentData);
        const uploadSuccess = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadSuccess');

        uploadFile(file.file, params, uploadSuccess, holderDocumentData.orderNm);
    }

    handleDownloadFile(holderDocumentData) {
        const { getDocument } = this.props;
        const params = this.buildParams(holderDocumentData);

        getDocument(params);
    }

    buildUploadProps(holderDocumentData) {
        const { immMortgageRequestDocumentationCenter } = this.props;
        const documentOrderNumberBeingExecuted = immMortgageRequestDocumentationCenter.get('documentOrderNumber');
        const { documentState, documentType, orderNm: documentOrderNumber } = holderDocumentData;
        const valid = documentState === DOCUMENTS_STATUS.VERIFICADO;
        const invalid = documentState === DOCUMENTS_STATUS.NO_VALIDO;
        const inValidation = includes([DOCUMENTS_STATUS.PEND_VAL, DOCUMENTS_STATUS.PEND_RESP_OCR], documentState);
        const error = !!immMortgageRequestDocumentationCenter.getIn(['error', documentType]);
        const loading = !!immMortgageRequestDocumentationCenter.getIn(['uploading', documentType]) && documentOrderNumberBeingExecuted === documentOrderNumber;
        const errorSize = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileErrorSize');
        const errorType = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileErrorType');
        const errorTypeSize = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileErrorTypeSize');
        const uploadText = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadText');
        const uploadLink = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadLink');

        let errorMessage = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileErrorMessage');
        let uploadedTitle = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadedTitle');
        let uploadedText = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadedText');
        let uploadedLink = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileUploadedLink');
        let file = null;
        let disabled = false;

        if (invalid) {
            uploadedTitle = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileInvalidUploadedTitle');
            uploadedText = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileInvalidUploadedText');
            uploadedLink = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileInvalidUploadedLink');
            errorMessage = null;
        }

        if (valid) {
            uploadedTitle = formatText('mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileValidUploadedTitle');
            uploadedText = null;
            uploadedLink = null;
            disabled = true;
        }

        if (valid || invalid || inValidation) {
            file = {};
        }

        return {
            type: UPLOAD_FILE_TYPE,
            disabled,
            file,
            texts: {
                errorSize,
                errorType,
                errorTypeSize,
                uploadText,
                uploadLink,
                uploadedTitle,
                uploadedText,
                uploadedLink
            },
            error,
            errorMessage,
            handlers: {
                change: file => this.handleUploadFile(file, holderDocumentData),
                download: () => this.handleDownloadFile(holderDocumentData)
            },
            downloadButton: true,
            invalid,
            inValidation,
            loading
        }
    }

    buildUploadContent(holderDocumentData) {
        const { documentState } = holderDocumentData;
        let uploadConst;

        if (documentState === DOCUMENTS_STATUS.EXENTO) {
            uploadConst = (
                <div className="mortgage-request-documentation-center-holders__list-item-upload-norequired">
                    <i className="icon icon-doc_norequerido mortgage-request-documentation-center-holders__list-item-upload-norequired--icon" />
                    <FormattedText value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionFileNotRequired" />
                </div>
            );
        } else {
            const uploadProps = this.buildUploadProps(holderDocumentData);
            uploadConst = (
                <OKFileUpload {...{ ...uploadProps }} />
            );
        }

        return uploadConst;
    }

    buildHoldersListItems(holders, hasCoholder) {

        return holders.map((holderRow, index) => {
            const itemUploadClassName = classNames('mortgage-request-documentation-center-holders__list-item-upload', {
                'mortgage-request-documentation-center-holders__list-item-upload--one-holder': !hasCoholder
            });
            const itemClassName = classNames('mortgage-request-documentation-center-holders__list-item', {
                'mortgage-request-documentation-center-holders__list-item--one-holder': !hasCoholder
            });
            const itemLabelClassName = classNames('mortgage-request-documentation-center-holders__list-item-label', {
                'mortgage-request-documentation-center-holders__list-item-label--one-holder': !hasCoholder
            });

            const getDocumentRow = (orderDocument) => {
                const document = holderRow.find(item => item.orderNm === orderDocument);
                return !!document ? (
                    <div className={itemUploadClassName}>
                        {this.buildUploadContent(document)}
                    </div>
                ) : null
            }

            return (
                <div key={index} className={itemClassName}>
                    <div className={itemLabelClassName}>
                        {holderRow[0].documentLabel}
                    </div>
                    {getDocumentRow(HOLDER_ORDER) || <div className={itemUploadClassName}></div>}
                    {getDocumentRow(COHOLDER_ORDER) || (hasCoholder && <div className={itemUploadClassName}></div>)}
                </div>
            );
        });
    }

    buildHoldersList() {
        const { holders } = this.props;
        const hasCoholder = holders.find(item => item.length > 1);
        const listHeader = this.buildListHeader(hasCoholder);
        const listItems = this.buildHoldersListItems(holders, hasCoholder);

        return (
            <div className="mortgage-request-documentation-center-holders__list">
                {listHeader}
                {listItems}
            </div>
        );
    }

    render() {
        const holdersList = this.buildHoldersList();
        return (
            <ContentBox
                title={formatText('mortgageRequestDocumentationCenter-subtitleSectionHolders')}
                titleSeparator
                customClassName="mortgage-request-documentation-center__section"
            >
                <FormattedText
                    value="mortgageRequestDocumentationCenter-mortgageRequestDocumentationCenter_holderSectionSubtitle"
                    className="mortgage-request-documentation-center-holders__subtitle"
                />
                <div className="row">
                    <div className="col-xs-12">
                        <Accordion customClassName="mortgage-request-holder-information__upload-dni-accordion" onClick={this.handleClick}>
                            <AccordionHeader name="AccordionHeader" isRightArrowPosition>
                                <FormattedText
                                    value="mortgageRequestDocumentationCenter-titleAccordion"
                                    className="mortgage-request-holder-information__upload-dni-accordion-header--title"
                                />
                            </AccordionHeader>
                            <AccordionBody name="AccordionBody">
                                <div className="mortgage-request-holder-information__upload-dni-accordion-body">
                                    <div className="row">
                                        <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item">
                                            <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-flat-surface" />
                                            <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction1" />
                                        </div>
                                        <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item mortgage-request-holder-information__upload-dni-accordion-body-item--border-left">
                                            <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-clear-image" />
                                            <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction2" />
                                        </div>
                                        <div className="col-xs-4 mortgage-request-holder-information__upload-dni-accordion-body-item mortgage-request-holder-information__upload-dni-accordion-body-item--border-left">
                                            <i className="icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon mortgage-request-holder-information__upload-dni-accordion-body-item--icon-natural-light" />
                                            <FormattedText value="mortgageRequestHolderInformation-dniUploadIntruction3" />
                                        </div>
                                    </div>
                                </div>
                            </AccordionBody>
                        </Accordion>
                        <br/>
                        <FormattedText value="mortgageRequestDocumentationCenter-sizeDescription" />

                    </div>

                </div>
                {holdersList}
            </ContentBox>
        );
    }
}

MortgageRequestDocumentationCenterHolders.propTypes = {
    holders: PropTypes.array,
    immMortgageRequestDocumentationCenter: PropTypes.object,
    uploadFile: PropTypes.func,
    getDocument: PropTypes.func
}

module.exports = MortgageRequestDocumentationCenterHolders;
